module.exports = __webpack_public_path__ + "img/icon_specialist_availability_calendar_hover.13ea1ea2.svg";